<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h5>Vendedor</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="codigo"
            name="codigo"
            placeholder="Escriba un código..."
            v-model="form.codigo"
          >
            Código
            <span
              v-if="errores.codigo"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.codigo[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="descripcion"
            name="descripcion"
            placeholder="Escriba un nombre o descripción..."
            v-model="form.descripcion"
          >
            Nombre/Descripción
            <span
              v-if="errores.descripcion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.descripcion[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="numero_identificacion"
            name="numero_identificacion"
            placeholder="Escriba una identificación..."
            v-model="form.numero_identificacion"
            :readonly="form.id != ''"
          >
            Número de identificación
            <span
              v-if="errores.numero_identificacion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.numero_identificacion[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            placeholder="Escriba una dirección..."
            id="direccion"
            name="direccion"
            v-model="form.direccion"
          >
            Dirección
            <span
              v-if="errores.direccion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.direccion[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            placeholder="Escriba uno o varios teléfonos..."
            id="telefonos"
            name="telefonos"
            v-model="form.telefonos"
          >
            Teléfono(s)
            <span
              v-if="errores.telefonos"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.telefonos[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            placeholder="Escriba uno o varios correos..."
            id="correos"
            name="correos"
            v-model="form.correos"
          >
            Correo(s)
            <span
              v-if="errores.correos"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.correos[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="guardar" class="btn-success">
        <i class="fa fa-save"></i><span>Guardar</span>
      </button>
      <button @click="cancelar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cancelar</span>
      </button>
      <button
        :v-show="form.id != ''"
        @click="clonar"
        class="btn-info btn--text"
      >
        <i class="fa fa-clone"></i><span>Crear como verificador</span>
      </button>
      <button
        :v-show="form.id != ''"
        @click="crearComoUsuario"
        class="btn-primary btn--text"
      >
        <i class="fa fa-users"></i><span>Crear como usuario</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: false,
      default: function () {
        return {
          descripcion: "",
          direccion: "",
          telefonos: "",
          correos: "",
          id: "",
          _method: undefined,
          numero_identificacion: "",
          codigo: "",
        };
      },
    },
  },
  methods: {
    crearComoUsuario: function () {
      window.open(url + '/usuarios/create?vendedor_id=' + this.form.id, '_blank');
    },
    clonar: function () {
      swal({
        title: "¿Desea crear el vendedor como verificador?",
        text: "Se registrará el verificador",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/logistica/clonar-vendedor/" + this.form.id)
            .then(() => {
              swal("El verificador ha sido creado.", "Realizado", "success");
            })
            .catch(({ response }) => {
              let status = response.status;
              if (status == 403) {
                swal(
                  "El verificador ya ha sido registrado con anterioridad.",
                  "Aviso",
                  "warning"
                );
              } else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    guardar: function () {
      this.errores = {};
      swal({
        title: "¿Desea guardar los cambios realizados?",
        text: "Se almacenará los datos del vendedor",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          let urlRequest = url + "/logistica/vendedores";
          if (this.form.id == "") this.form._method = undefined;
          else {
            this.form._method = "PUT";
            urlRequest += "/" + this.form.id;
          }
          axios
            .post(urlRequest, this.form)
            .then(() => {
              swal(
                "El vendedor fue almacenado exitósamente.",
                "Realizado",
                "success"
              );
              this.$emit("saved");
            })
            .catch(({ response }) => {
              let status = response.status;
              if (status == 422) {
                swal("Hay errores en el formulario.", "Aviso", "warning");
                this.errores = response.data.errors;
              } else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    cancelar: function () {
      this.$emit("cancelar");
    },
  },
  data: function () {
    return {
      form: JSON.parse(JSON.stringify(this.value)),
      errores: {},
    };
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/vendedores/Vendedor.vue